import { createContext, useContext, useState } from "react";


export const HotelContext = createContext(null);


export const HotelProvider = ({ children }) => {


    const [Hotel, setHotel] = useState({

        HotelId: 0
    })


    return (
        <HotelContext.Provider value={{ Hotel, setHotel }}>
            {children}
        </HotelContext.Provider>
    )
}

export const useHotel = () => useContext(HotelContext)
